import { gql } from '@apollo/client';

export const GET_USER_POOL_CLIENT_ID = gql`
  query getUserPoolClientId {
    getUserPoolClientId {
      userPoolClientId
      userPoolId
    }
  }
`;

export const GET_RANGE_CAM_TOKEN = gql`
  query getRangecamToken {
    getRangecamToken {
      header
      value
    }
  }
`;


export const QUERY_ANNOUNCEMENTS = gql`
  query queryAnnouncements (
    $announcement_types: [AnnouncementType]
    $end: Float
    $next_token: String
    $size: Int
    $start: Float
  ) {
    queryAnnouncements(
      announcement_types: $announcement_types
      end: $end
      next_token: $next_token
      size: $size
      start: $start
    ) {
      announcements {
        announcement_details {
          announcement_date
          announcement_published_by
          announcement_text
          announcement_ttl
          announcement_type
          is_public
        }
        announcement_id
      }
      nextToken
    }
  }
`;

export const ADD_ANNOUNCEMENT = gql`
  mutation addAnnouncement(
    $announcement_id: String
    $announcement_details: AnnouncementDetailsInput!
  ) {
    addAnnouncement(
      announcement_id: $announcement_id
      announcement_details: $announcement_details
    ) {
      announcement_id
    }
  }
`;

export const UPDATE_ANNOUNCEMENT = gql`
  mutation updateAnnouncement(
    $announcement_id: String!
    $announcement_details: AnnouncementDetailsInput!
  ) {
    updateAnnouncement(
      announcement_id: $announcement_id
      announcement_details: $announcement_details
    ) {
      announcement_id
    }
  }
`;

export const DELETE_ANNOUNCEMENT = gql`
  mutation deleteAnnouncement(
    $announcement_id: String!
  ) {
    deleteAnnouncement(
      announcement_id: $announcement_id
    ) {
      announcement_id
    }
  }
`;

export const GET_MEMBERS_BY_LAST_INITIAL = gql`
  query getMembersByLastInitial(
    $initial: String
    $next_token: String
    $size: Int
  ) {
    getMembersByLastInitial(
      initial: $initial
      next_token: $next_token
      size: $size
    ) {
      members {
        member_email
        member_details {
          date_of_birth
          gate_card
          is_current
          last_orientation_date
          last_renewal_date
          member_app_url
          member_application_id
          member_email
          member_first_name
          member_groups
          member_last_name
          member_phone_number
          member_since
          member_type
          nra_id
          second_amendment_org
          org_membership_id
          org_membership_type
          org_expiration_date
          paid_through
          signup_status
          cognito_user_id
        }
      }
    }
  }
`;

export const GET_MEMBER = gql`
  query getMember {
    getMember {
      member_email
      member_details {
        member_first_name
        member_last_name
        member_type
        member_since
        last_renewal_date
        paid_through
        is_current
        gate_card
        nra_id
        second_amendment_org
        org_membership_id
        org_membership_type
        org_expiration_date
      }
    }
  }
`;

export const ADMIN_GET_MEMBER = gql`
  query adminGetMember(
    $member_email: String!
  ) {
    adminGetMember(
      member_email: $member_email
    ) {
      member_email
      member_details {
        date_of_birth
        gate_card
        is_current
        login_status
        last_renewal_date
        last_orientation_date
        member_app_url
        member_application_id
        member_email
        member_first_name
        member_groups
        member_last_name
        member_phone_number
        member_since
        member_type
        nra_id
        second_amendment_org
        org_membership_id
        org_membership_type
        org_expiration_date
        paid_through
        signup_status
        cognito_user_id
      }
    }
  }
`;

export const ADD_MEMBER = gql`
  mutation addMember(
    $member_details: MemberDetailsInput!
  ) {
    addMember(
      member_details: $member_details
    ) {
      member_email
      member_details {
        date_of_birth
        gate_card
        is_current
        login_status
        last_renewal_date
        last_orientation_date
        member_app_url
        member_application_id
        member_email
        member_first_name
        member_groups
        member_last_name
        member_phone_number
        member_since
        member_type
        nra_id
        second_amendment_org
        org_membership_id
        org_membership_type
        org_expiration_date
        paid_through
        signup_status
        cognito_user_id
      }
    }
  }
`;

export const UPDATE_MEMBER = gql`
  mutation updateMember(
    $member_details: MemberDetailsInput!
    $member_email: String!
  ) {
    updateMember(
      member_details: $member_details
      member_email: $member_email
    ) {
      member_email
      member_details {
        date_of_birth
        gate_card
        is_current
        login_status
        last_renewal_date
        last_orientation_date
        member_app_url
        member_application_id
        member_email
        member_first_name
        member_groups
        member_last_name
        member_phone_number
        member_since
        member_type
        nra_id
        second_amendment_org
        org_membership_id
        org_membership_type
        org_expiration_date
        paid_through
        signup_status
        cognito_user_id
      }
    }
  }
`;

export const DELETE_MEMBER = gql`
  mutation deleteMember(
    $member_email: String!
  ) {
    deleteMember(
      member_email: $member_email
    ) {
      member_email
      member_details {
        date_of_birth
        gate_card
        is_current
        login_status
        last_renewal_date
        last_orientation_date
        member_app_url
        member_application_id
        member_email
        member_first_name
        member_groups
        member_last_name
        member_phone_number
        member_since
        member_type
        nra_id
        second_amendment_org
        org_membership_id
        org_membership_type
        org_expiration_date
        paid_through
        signup_status
        cognito_user_id
      }
    }
  }
`;

export const RESEND_MEMBER_WELCOME_EMAIL = gql`
  mutation resendMemberWelcomeEmail(
    $member_email: String!
  ) {
    resendMemberWelcomeEmail(
      member_email: $member_email
    ) {
      success
      message
    }
  }
`;

export const QUERY_PUBLISHED_NEWSLETTERS = gql`
  query queryPublishedNewsletters(
    $end: Float
    $next_token: String
    $size: Int
    $start: Float
  ) {
    queryPublishedNewsletters(
      end: $end
      next_token: $next_token
      size: $size
      start: $start
    ) {
      newsletters {
        newsletter_id
        newsletter_details {
          newsletter_date
          newsletter_name
          newsletter_published_by
          newsletter_published_date
          newsletter_s3_bucket
          newsletter_s3_key
          newsletter_status
          newsletter_ttl
          newsletter_url
          document_type
        }
      }
      nextToken
    }
  }
`;

export const QUERY_DOCUMENTS_BY_TYPE = gql`
  query queryDocumentsByType(
    $document_type: DocumentType!
    $next_token: String
    $size: Int
  ) {
    queryDocumentsByType(
      document_type: $document_type
      next_token: $next_token
      size: $size
    ) {
      newsletters {
        newsletter_id
        newsletter_details {
          newsletter_date
          newsletter_name
          newsletter_published_by
          newsletter_published_date
          newsletter_s3_bucket
          newsletter_s3_key
          newsletter_status
          newsletter_ttl
          newsletter_url
          document_type
        }
      }
      nextToken
    }
  }
`;

export const GET_NEWSLETTER = gql`
  query getNewsletter(
    $newsletter_id: String!
  ) {
    getNewsletter(
      newsletter_id: $newsletter_id
    ) {
      newsletter_id
      newsletter_details {
        newsletter_date
        newsletter_name
        newsletter_published_by
        newsletter_published_date
        newsletter_s3_bucket
        newsletter_s3_key
        newsletter_status
        newsletter_ttl
        newsletter_url
        newsletter_upload_url {
          fields
          url
        }
      }
    }
  }
`;

export const ADD_NEWSLETTER = gql`
  mutation addNewsletter(
    $newsletter_details: NewsletterDetailsInput!
    $newsletter_id: String!
  ) {
    addNewsletter (
      newsletter_details: $newsletter_details
      newsletter_id: $newsletter_id
    ) {
      newsletter_details {
        newsletter_date
        newsletter_name
        newsletter_published_by
        newsletter_published_date
        newsletter_s3_bucket
        newsletter_s3_key
        newsletter_status
        newsletter_ttl
        newsletter_upload_url {
          fields
          url
        }
        newsletter_url
      }
      newsletter_id
    }
  }
`;

export const UPDATE_NEWSLETTER = gql`
  mutation updateNewsletter(
    $newsletter_details: NewsletterDetailsInput!
    $newsletter_id: String!
  ) {
    updateNewsletter (
      newsletter_details: $newsletter_details
      newsletter_id: $newsletter_id
    ) {
      newsletter_details {
        newsletter_date
        newsletter_name
        newsletter_published_by
        newsletter_published_date
        newsletter_s3_bucket
        newsletter_s3_key
        newsletter_status
        newsletter_ttl
        newsletter_upload_url {
          fields
          url
        }
        newsletter_url
      }
      newsletter_id
    }
  }
`;

export const DELETE_NEWSLETTER = gql`
  mutation deleteNewsletter(
    $newsletter_id: String!
  ) {
    deleteNewsletter(
      newsletter_id: $newsletter_id
    ) {
      newsletter_id
      newsletter_details {
        newsletter_date
        newsletter_name
        newsletter_published_by
        newsletter_published_date
        newsletter_s3_bucket
        newsletter_s3_key
        newsletter_status
        newsletter_ttl
        newsletter_url
        newsletter_upload_url {
          fields
          url
        }
      }
    }
  }
`;



// ============================================================================
// MATCH RESULTS SYSTEM QUERIES
// ============================================================================

// Match Format Queries
export const LIST_MATCH_FORMATS = gql`
  query ListMatchFormats(
    $match_category: String
    $match_discipline: MatchDiscipline
    $is_template: Boolean
  ) {
    listMatchFormats(
      match_category: $match_category
      match_discipline: $match_discipline
      is_template: $is_template
    ) {
      format_id
      format_details {
        format_name
        match_category
        match_discipline
        competition_type
        bracket_config {
          bracket_type
          seeding_method
          num_participants
        }
        stage_aggregation_method
        divisions
        categories
        stages {
          stage_name
          stage_order
          target_count
          target_aggregation_method
          scoring_primitive
          parameters {
            max_score
            shots_per_target
            min_shots_per_target
            time_limit
            par_time
            x_count
            inner_tens
            clean_targets
          }
          weight
        }
        is_template
        created_by
        created_at
      }
    }
  }
`;

export const GET_MATCH_FORMAT = gql`
  query GetMatchFormat($format_id: String!) {
    getMatchFormat(format_id: $format_id) {
      format_id
      format_details {
        format_name
        match_category
        match_discipline
        competition_type
        bracket_config {
          bracket_type
          seeding_method
          num_participants
        }
        stages {
          stage_name
          stage_order
          target_count
          target_aggregation_method
          scoring_primitive
          parameters {
            max_score
            shots_per_target
            min_shots_per_target
            time_limit
            par_time
            x_count
            inner_tens
            clean_targets
          }
          weight
          stage_points
        }
        stage_aggregation_method
        divisions
        categories
        tiebreaker_rules {
          enabled
          method
          steps {
            order
            type
            field
            stage_id
            direction
            label
            shootoff_type
            target_count
            shots_per_round
          }
        }
        is_template
        created_by
        created_at
        updated_at
      }
    }
  }
`;

// Match Queries
export const QUERY_MATCHES = gql`
  query QueryMatches(
    $match_category: String
    $match_discipline: MatchDiscipline
    $status: MatchStatus
    $start_date: Float
    $end_date: Float
    $match_director: String
  ) {
    queryMatches(
      match_category: $match_category
      match_discipline: $match_discipline
      status: $status
      start_date: $start_date
      end_date: $end_date
      match_director: $match_director
    ) {
      match_id
      match_details {
        match_name
        match_category
        match_discipline
        match_date
        match_format_id
        match_status
        match_location
        match_director
        match_director_email
        match_description
        max_participants
        registration_deadline
      }
    }
  }
`;

export const GET_MATCH = gql`
  query GetMatch($match_id: String!) {
    getMatch(match_id: $match_id) {
      match_id
      match_details {
        match_name
        match_category
        match_discipline
        match_date
        match_format_id
        match_status
        match_location
        match_director
        registration_deadline
        max_participants
        match_description
        weather_conditions
        created_at
        updated_at
      }
    }
  }
`;

// Match Result Queries
export const GET_MATCH_RESULTS = gql`
  query GetMatchResults(
    $match_id: String!
    $division: String
    $category: String
  ) {
    getMatchResults(
      match_id: $match_id
      division: $division
      category: $category
    ) {
      result_id
      result_details {
        match_id
        participant_name
        participant_email
        division
        category
        stage_scores {
          stage_name
          scoring_primitive
          score_data {
            value
            points
            time
            x_count
            inner_tens
            clean_targets
          }
          calculated_value
        }
        aggregate_score
        placement
        tiebreaker_data {
          shootoff_1_score
          shootoff_2_score
          shootoff_3_score
          custom_fields {
            field
            value
          }
        }
        rank_note
        total_x_count
        total_inner_tens
        total_clean_targets
        notes
        verified
        entered_by
        created_at
        updated_at
      }
    }
  }
`;

// Match Format Mutations
export const CREATE_MATCH_FORMAT = gql`
  mutation CreateMatchFormat($format_details: MatchFormatDetailsInput!) {
    createMatchFormat(format_details: $format_details) {
      format_id
      format_details {
        format_name
        match_category
        match_discipline
        created_at
      }
    }
  }
`;

export const UPDATE_MATCH_FORMAT = gql`
  mutation UpdateMatchFormat(
    $format_id: String!
    $format_details: MatchFormatDetailsInput!
  ) {
    updateMatchFormat(
      format_id: $format_id
      format_details: $format_details
    ) {
      format_id
      format_details {
        format_name
        match_category
        match_discipline
        competition_type
        bracket_config {
          bracket_type
          seeding_method
          num_participants
        }
        stages {
          stage_name
          stage_order
          target_count
          target_aggregation_method
          scoring_primitive
          parameters {
            max_score
            shots_per_target
            min_shots_per_target
            time_limit
            par_time
            x_count
            inner_tens
            clean_targets
          }
          weight
          stage_points
        }
        stage_aggregation_method
        divisions
        categories
        tiebreaker_rules {
          enabled
          method
          steps {
            order
            type
            field
            stage_id
            direction
            label
            shootoff_type
            target_count
            shots_per_round
          }
        }
        is_template
        created_by
        created_at
        updated_at
      }
    }
  }
`;

export const DELETE_MATCH_FORMAT = gql`
  mutation DeleteMatchFormat($format_id: String!) {
    deleteMatchFormat(format_id: $format_id) {
      format_id
    }
  }
`;

// Match Mutations
export const CREATE_MATCH = gql`
  mutation CreateMatch($match_details: MatchDetailsInput!) {
    createMatch(match_details: $match_details) {
      match_id
      match_details {
        match_name
        match_date
        match_status
        created_at
      }
    }
  }
`;

export const UPDATE_MATCH = gql`
  mutation UpdateMatch(
    $match_id: String!
    $match_details: MatchDetailsInput!
  ) {
    updateMatch(
      match_id: $match_id
      match_details: $match_details
    ) {
      match_id
      match_details {
        match_name
        match_status
        updated_at
      }
    }
  }
`;

export const DELETE_MATCH = gql`
  mutation DeleteMatch($match_id: String!) {
    deleteMatch(match_id: $match_id) {
      match_id
    }
  }
`;

// Match Result Mutations
export const ADD_MATCH_RESULT = gql`
  mutation AddMatchResult($result_details: MatchResultDetailsInput!) {
    addMatchResult(result_details: $result_details) {
      result_id
      result_details {
        participant_name
        aggregate_score
        placement
        created_at
      }
    }
  }
`;

export const UPDATE_MATCH_RESULT = gql`
  mutation UpdateMatchResult(
    $result_id: String!
    $result_details: MatchResultDetailsInput!
  ) {
    updateMatchResult(
      result_id: $result_id
      result_details: $result_details
    ) {
      result_id
      result_details {
        participant_name
        aggregate_score
        placement
        updated_at
      }
    }
  }
`;

export const DELETE_MATCH_RESULT = gql`
  mutation DeleteMatchResult($result_id: String!) {
    deleteMatchResult(result_id: $result_id) {
      result_id
    }
  }
`;

export const BULK_ADD_MATCH_RESULTS = gql`
  mutation BulkAddMatchResults(
    $match_id: String!
    $results: [MatchResultDetailsInput!]!
  ) {
    bulkAddMatchResults(
      match_id: $match_id
      results: $results
    ) {
      result_id
      result_details {
        participant_name
        aggregate_score
      }
    }
  }
`;
